/* eslint-disable react/prop-types */
import * as React from "react";
import {
  Routes,
  Route,
  Navigate,
  useNavigate,
  useLocation,
} from "react-router-dom";
import { deleteCookie } from "../utils/helper";
// import firebase from "../utils/firebase";
import Login from "../app/pages/Login";
import ControlCenter from "../app/modules/ControlCenter";
import Communication from "../app/modules/Communication";
import AddControlCenter from "../app/modules/ControlCenter/components/AddACLGroup";
import Calendar from "../app/modules/Calendar";
import RequestAccess from "../app/modules/RequestAccess";

import DashboardLayout from "../app/molecules/DashboardLayout";
import AuthTransfer from "../app/atoms/AuthTransfer";
import { authService } from "../configs/constants";
import Ticketing from "../app/modules/Ticketing";
import NewIssueScreen from "../app/modules/Ticketing/NewIssue";
import RtaPermit from "../app/modules/RtaPermit";
import IssueDetails from "../app/modules/Ticketing/components/issueDetails";

function isAuthenticated(isDashboard?: boolean) {
  const login = JSON.parse(localStorage.getItem("login-response"));
  const sso = JSON.parse(localStorage.getItem("sso-login"));
  const ssoUser = JSON.parse(localStorage.getItem("sso-user"));

  const idToken = document.cookie
    .split("; ")
    .find((row) => row.startsWith("idToken="));

  try {
    if (login?.accessToken || idToken || ssoUser) {
      return true;
    }
    if (!login?.accessToken && sso?.isValid && !isDashboard) {
      return true;
    }
    return false;
  } catch (err) {
    return false;
  }
}

function clearAll() {
  deleteCookie("carsTaxiUser");
  localStorage.clear();
  sessionStorage.clear();
}

const Pages = (props) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [delay, setDelay] = React.useState(false);
  const sublocation = location?.pathname as unknown as { from: string };

  const afterLoginRoute = async () => {
    if (location.pathname !== "/login" && location.pathname !== "/") {
      await sessionStorage.setItem(
        "afterLoginRoute",
        sublocation + location.search + location.hash
      );
    }
  };

  React.useEffect(() => {
    afterLoginRoute();
  }, []);

  React.useEffect(() => {
    setTimeout(() => {
      setDelay(true);
    }, 500);
  }, []);

  return (
    <>
      <Routes>
        {/* public routes */}
        <Route path="/" element={<AuthTransfer ssoRoot={true} />} />
        <Route path="/login" element={<Login />} />
      </Routes>
      {/* private routes */}
    
      {isAuthenticated() && (
        <DashboardLayout load={false}>
          <Routes>
            <Route path="/settings" element={<ControlCenter />} />
            <Route path="/add-control-center" element={<AddControlCenter />} />
            <Route path="/request-access" element={<RequestAccess />} />
            <Route path="/comm" element={<Communication />} />
            <Route path="/roaster" element={<Calendar />} />
            <Route path="/ticketing" element={<Ticketing />} />
            <Route path="/ticketing/new-ticket" element={<NewIssueScreen />} />
            <Route path="/ticketing/details/:id" element={<IssueDetails />} />
            <Route path="/RtaPermit" element={<RtaPermit />} />
          </Routes>
        </DashboardLayout>
      )}

      {isAuthenticated() && (
        <Routes>
          <Route
            path="/auth-transfer"
            element={<AuthTransfer ssoRoot={true} />}
          />
          <Route
            path="/auth-success"
            element={<AuthTransfer final={"success"} />}
          />
        </Routes>
      )}

      {!isAuthenticated() && delay && (
        <>
          {clearAll()}
          <Routes>
            <Route path="*" element={<Navigate to="/login" replace />} />
          </Routes>
        </>
      )}
    </>
  );
};

export default Pages;
